import Noty from "noty";
import "../../node_modules/noty/lib/noty.css";
import "../../node_modules/noty/lib/themes/relax.css";
import { APP_ENV } from "@/APP_ENV";

export const successHandling = (t, successfulText, type, afterShow) => {
  new Noty({
    type: type,
    theme: "relax",
    layout: "topRight",
    closeWith: ["click", "button"],
    timeout: APP_ENV.REACT_APP_NOTY_TIMEOUT || 3000,
    text: `${t(successfulText)}`,
    callbacks: {
      afterShow: afterShow
    }
  }).show();
};
